import React, { createContext, useContext, useState } from 'react';

const TripDetailsContext = createContext();

export const useTripDetails = () => {
  const context = useContext(TripDetailsContext);
  if (!context) {
    // Return default values if context is not available (for components outside provider)
    return { showTripDetails: false, setShowTripDetails: () => {} };
  }
  return context;
};

export const TripDetailsProvider = ({ children }) => {
  const [showTripDetails, setShowTripDetails] = useState(false);

  return (
    <TripDetailsContext.Provider value={{ showTripDetails, setShowTripDetails }}>
      {children}
    </TripDetailsContext.Provider>
  );
};

export { TripDetailsContext };

